<template>
  <!-- 面包屑导航 -->
  <div class="breadcrumb">
    <el-breadcrumb separator="/" style="margin-top: 4px">
      <el-breadcrumb-item
        v-for="(item, index) in breadcrumbSearch.list"
        :key="index"
      >
        {{ item.title }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <!-- 面包屑导航 -->
</template>
<script>
export default {
  name: 'breadcrumbSearch',
  props: {
    breadcrumbSearch: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {

    }
  },
  created () { },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.breadcrumb {
  padding-bottom: 10px;
}
::v-deep .el-breadcrumb__separator {
  margin-left: 7px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #303033;
}
/* 不被选中时的颜色 */
.el-breadcrumb ::v-deep .el-breadcrumb__inner {
  color: #303033 !important;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold !important;
}
/* 被选中时的颜色 */
.el-breadcrumb__item:last-child ::v-deep .el-breadcrumb__inner {
  color: #303033 !important;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold !important;
  line-height: 20px;
}
</style>
